import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {GoogleLoginProvider, SocialAuthService, SocialUser} from 'angularx-social-login';
import {Subscription} from 'rxjs';
import {AuthService} from '../service/auth.service';
import {ProfileClient} from '../shared/interfaces';

@Component({
  selector: 'app-login',
  template: `
    <div id="login" class="container square-box d-flex justify-content-center align-items-center">
          <form><div class="mb-3">
                <label for="peerIdShare4Name" class="form-label">Your Name</label>
                <input type="text" class="form-control" id="peerIdShare4Name" aria-describedby="emailHelp"
                       [(ngModel)]='peerIdShare4Name' [ngModelOptions]="{standalone: true}">
                <div id="emailHelp" class="form-text">Please input You Name</div>
            <div *ngIf="error" class="invalid-feedback">
              {{error}}
            </div>
            </div>
<!--            <div class="mb-3">-->
<!--                <label for="exampleInputPassword1" class="form-label">Password</label>-->
<!--                <input type="password" class="form-control" id="exampleInputPassword1">-->
<!--            </div>-->
<!--            <div class="mb-3 form-check">-->
<!--                <input type="checkbox" class="form-check-input" id="exampleCheck1">-->
<!--                <label class="form-check-label" for="exampleCheck1">Check me out</label>-->
<!--            </div>-->
            <button type="button" class="btn btn-primary" (click)="chaneName()">Login</button>
            <a href="JavaScript:void(0);" (click)="loginWithGoogle()" class="btn btn-just-icon btn-link btn-white">
              <i class="fa fa-google-plus">google</i>
            </a>
          </form>
    </div>

  `,
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  public   peerIdShare4Name: string;
  public   error: string;
  subSocial: Subscription;
  constructor(private router: Router,
              private socialAuthService: SocialAuthService,
              private auth: AuthService) {

    this.peerIdShare4Name = localStorage.getItem('rb-peer');
    if ( this.peerIdShare4Name === null ){
      this.peerIdShare4Name = '';
      this.error =  'His Login is exist!!!';
    }else{
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {

    this.subSocial=this.socialAuthService.authState.subscribe((user) => {
      this.auth.soclogin(user).subscribe((us: ProfileClient) => {
        console.log('us', us);
        localStorage.setItem('rb-peer', us.id);
        this.router.navigate(['/']);
      })

    });
  }

  chaneName(): void {
    localStorage.setItem('rb-peer', this.peerIdShare4Name);
    this.router.navigate(['/']);
  }
  loginWithGoogle(): void {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  ngOnDestroy(): void {
      if (this.subSocial){
        this.subSocial.unsubscribe();
      }
  }
}


